import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Progressbar from './Progressbar';

class ProgressbarExample extends Component {

  state = {
    value: 50,
    width: 90,
  };

  onChange = (e, key, value) => {
    // HACK for Chrome. Adjusting the width on the fly doesn't repaint the progress bar correctly. Works in other browsers
    if (this.state.circular && key === 'width') {
      this.setState({
        circular: false,
      }, () => {
        this.setState({
          circular: true,
          width: value,
        });
      });
    } else {
      this.setState(e.target.value);
    }
  };

  render() {
    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={Progressbar.defaultProps} propTypes={Progressbar.propTypes} propValues={this.state}/>
        <Progressbar {...this.state}/>
        <SourceCode querySelector=".progressbar-example .core-progressbar"/>
      </Example>
    );
  }

}

ProgressbarExample.tags = 'indeterminate';

export default ProgressbarExample;
